
<ngx-spinner type="ball-beat"></ngx-spinner>
<toast-container aria-live="polite" aria-atomic="true"></toast-container>
<div class="celerity-root">
  <router-outlet></router-outlet>
</div>
